import bioStore from "./modules/bio/bioStore";
import academicStore from "./modules/academic/academicStore";
import contactStore from "./modules/contact/contactStore";
import experienceStore from "./modules/experience/experienceStore";
import refereeStore from "./modules/referee/refereeStore";
import specializationStore from "./modules/specialization/specializationStore";
// import { AuthService } from "../dashboard/modules/auth";
import { call } from "../dashboard/service";
import profileConstants from "./profileConstants";
export default {
  namespaced: true,
  modules: {
    bioStore,
    academicStore,
    contactStore,
    experienceStore,
    refereeStore,
    specializationStore,
  },

  state: {
    actions: [
      {
        name: "Incomplete Profile",
        icon: "mdi-alert",
        to: { name: "Check List", param: { type: "Application" } },
      },
    ],
    cities: [],
    counties: [],
    countries: [],
    postalCodes: [],
    types: [],
    levels: [],
    industryGroup: [],
    certificationClass: [],
    certificationCodes: [],
    qualificationCodes: [],
    settings: {},
  },

  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },

  getters: {
    setupGetter: (state) => (setup) => state[setup],
  },

  actions: {
    getProfile: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", profileConstants.profile)
        .then((res) => {
          commit("SET_BIO_DATA", res.data.data[0]);
          commit("SET_CONTACTS", res.data.data[0].userContacts);
          commit("SET_ACADEMICS", res.data.data[0].studentAcademics);
          commit("SET_EXPERIENCE", res.data.data[0].experience);
          commit("SET_REFEREE", res.data.data[0].referees);
          commit("SET_SPECIALIZATION", res.data.data[0].specialization);
          commit("Dashboard/SET_LOADING", false, { root: true });
          // ...
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },

    // get profile setup
    // eslint-disable-next-line no-unused-vars
    setupAction: async ({ commit, dispatch }, collection) => {
      const response = [];
      await Promise.all(
        collection.map((item) =>
          call("get", item.url).then((res) => {
            response.push({
              payload: res.data.data,
              stateField: item.stateField,
            });
          }),
        ),
      );
      return response;
    },
    // eslint-disable-next-line no-unused-vars
    getAllSetup: ({ commit, dispatch }, data) => {
      // get all setups
      commit("Dashboard/SET_LOADING", true, { root: true });
      const collection = [];
      const constants = profileConstants.profileSetup;
      Object.keys(constants).forEach((key, index) => {
        collection[index] = {
          stateField: key,
          url: constants[key],
        };
      });
      dispatch("setupAction", collection)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          res.map((item) => {
            commit("MUTATE", { data: item.payload, state: item.stateField });
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getSettings: ({ commit }) => {
      call("get", profileConstants.settings)
        .then((res) => {
          commit("MUTATE", { state: "settings", data: res.data.data });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
